module.exports = __webpack_public_path__ + "static/media/liveNowPrivate.24318400.svg";